export const CAST_AI = 'Cast AI';

/** Single source of truth for the AI assistant product name. */
export const CAST_PILOT_ASSISTANT = 'CastPilot Assistant';
